import { PayoutConfigData } from "@lib/titan2-slingo/dist/api/model/data/PayoutConfigData";
import { SlingoConstants } from "@lib/titan2-slingo/dist/api/model/enum/SlingoConstants";
import { Dictionary } from "@lib/titan2/dist/util/collection/Dictionary";
import { ExtendedSymbolPayoutData } from "./ExtendedSymbolPayoutData";
/**
 * ExtendedPayoutConfigData.ts
 */
export class ExtendedPayoutConfigData extends PayoutConfigData {
    solidifySymbolPayouts() {
        let symbolPayouts = this.data.getDataArray(SlingoConstants.PROPERTY_SYMBOL_PAYOUTS);
        this.symbolPayouts = new Dictionary();
        if (this.dataExists(symbolPayouts)) {
            for (let i = 0; i < symbolPayouts.length; i++) {
                let payout = new ExtendedSymbolPayoutData(symbolPayouts[i]);
                this.symbolPayouts.setValue(payout.getType(), payout);
            }
        }
    }
}
//# sourceMappingURL=ExtendedPayoutConfigData.js.map